/**
 * Controla el diálogo de rechazar tarea.
 */
RelacionarIncidenciaDialogCtrl.$inject = ['$log', '$scope'];
export default function RelacionarIncidenciaDialogCtrl($log, $scope) {

    $scope.model.motivos = ['duplicada', 'relacionada'];
    $scope.model.motivo = $scope.model.motivos[0];
    $scope.model.descripcion = null;

    $scope.urlBuscaTareas = Sigo.var.path + '/incidencias/incidencias-sin-relacionar/' + $scope.model.id + '/';

}